import React from 'react'
import {Timer} from './Timer';
import { MdCancel } from "react-icons/md";
import { FaRegTrashAlt } from "react-icons/fa";
import { CiEdit } from "react-icons/ci";

export const Button = ({name, type, action, icon, timer, timerCallback, buttonType = 'button'}) => {
    const variant = (type || 'PRIMARY').toUpperCase();
    const isDisabled = variant === 'DISABLED';

    const variants = {
        PRIMARY: 'bg-gradient-to-r from-cyan-400 to-blue-500 text-slate-950 hover:from-cyan-300 hover:to-blue-400',
        CANCEL: 'bg-gradient-to-r from-amber-300 to-yellow-500 text-slate-950 hover:from-amber-200 hover:to-yellow-400',
        DELETE: 'bg-gradient-to-r from-rose-500 to-red-600 text-white hover:from-rose-400 hover:to-red-500',
        EDIT: 'bg-gradient-to-r from-amber-300 to-orange-400 text-slate-950 hover:from-amber-200 hover:to-orange-300',
        SECONDARY: 'bg-white/10 text-white border border-white/20 hover:bg-white/15',
        DISABLED: 'bg-slate-700/70 text-slate-300 border border-slate-600 cursor-not-allowed'
    };

    if (variant === 'CANCEL' && !icon) icon = <MdCancel />;
    if (variant === 'DELETE' && !icon) icon = <FaRegTrashAlt />;
    if (variant === 'EDIT' && !icon) icon = <CiEdit />;

    return (
        <button
            type={buttonType}
            onClick={isDisabled ? undefined : action}
            disabled={isDisabled}
            className={`inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold tracking-wide shadow-lg shadow-slate-950/20 transition-all duration-200 ${isDisabled ? '' : 'hover:-translate-y-0.5'} ${variants[variant] || variants.PRIMARY}`}
        >
            {icon ? <span className="text-base">{icon}</span> : null}
            <span>{name}</span>
            {timer ? <span className="rounded-md bg-black/10 px-2 py-0.5 text-xs"><Timer startTime={timer} timeoutCallBack={timerCallback}/></span> : null}
        </button>
    )
}
